module.exports = __webpack_public_path__ + "static/img/c2.3b7070f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/c2.jpg
// module id = C6+g
// module chunks = 11